// extracted by mini-css-extract-plugin
module.exports = {"layout":"LayoutHome_layout_26pD6","content":"LayoutHome_content_3DTul","header":"LayoutHome_header_1wnFP"};